<div class="question-container d-flex justify-content-center pt-5 pb-2 align-items-start">
  <div class="main">

    <div class="d-flex justify-content-between ">
      <div class="w-100 d-flex flex-column gap-2 ">
        <div class="d-flex justify-content-between" style="width: 95%;">
          <span class="text-12-400-133 secondary">{{'Questions completed' | translate}}</span>
          <span class="text-12-500-183 secondary">
            {{questionStatus?.answered_questions}}/{{questionStatus?.total_questions}}
          </span>
        </div>
        <div class="progress">
          <div class="progress-bar bg-primary" role="progressbar" [style.width.%]="questionStatus?.attempted_percentage"
            aria-valuenow="12" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
      <img width="16" (click)="confirmQuit()" class="d-block d-sm-none align-self-end" src="assets/icons/close.svg" alt="close.svg">
      <button (click)="confirmQuit()" class="d-none d-sm-block secondary-btn text-16-500-125">{{'Quit' | translate}}</button>
    </div>

    <!-- badge earned animation -->
    <ng-container *ngIf="badgeEarnedAnimation">
      <app-badge-earned [badge]="this.questionStatus?.badge"></app-badge-earned>
    </ng-container>
    <div *ngIf="!badgeEarnedAnimation" class="mt-4">
      <div>
        <div class="d-flex badge-score justify-content-between">
            <div *ngIf="!this.SdgFlow" class="d-flex gap-3 sm-filters mt-4 col-5">
              <!-- Countries filter -->
              <app-select-input
              [ngClass]="{'cursor-none': this.answerSubmitted , 'op-50': this.answerSubmitted}"
              class="col-5"
              [label]=""
              [optionList]="lstCountries"
              [selectedId]="this.selectedCountryId"
              (onItemChange)="countryChange($event)">
              </app-select-input>
  
              <div class="input-container-value">
                <span class="">{{'All categories' | translate}}</span>
              </div>
            </div>
            <div *ngIf="this.SdgFlow" class="d-flex gap-3 sm-filters mt-4 col-5">
              <div class="input-container-value">
                <img src="assets/icons/all-countries.svg" alt="">
                <span class="ms-3">{{'All countries' | translate}}</span>
              </div>
              <!-- Category filter -->
              <app-select-input
              [ngClass]="{'cursor-none': this.answerSubmitted , 'op-50': this.answerSubmitted}"
              class="col-5"
              [label]=""
              [optionList]="sdgOptionList"
              [selectedId]="this.sdgId"
              (onItemChange)="subjectChange($event)">
              </app-select-input>
            </div>
          <div class="col-6 d-flex align-items-end justify-content-end gap-3 ">
            <div class="d-flex score-chip">
              <div class="text-16-500-125 ">
                {{'Score' | translate}}:
              </div>
              <div class="text-16-500-125">
                <!-- {{0}} / {{200}} -->
                {{questionStatus?.score}} / {{questionStatus?.maximum_score}}
              </div>
            </div>
            <div *ngIf="this.questionStatus?.badge == 'None'" class="score-chip-no-badge d-flex">
              <img src="/assets/icons/no-badge.svg" alt="">
              <div class="text-20-600-120 text-c">
                {{'No badge' | translate }}
              </div>
            </div>
            <div *ngIf="this.questionStatus?.badge == 'Bronze'" class="score-chip-bronze d-flex">
              <img src="/assets/icons/bronze-badge.svg" alt="">
              <div class="text-20-600-120 c-bronze">
                {{'Bronze badge' | translate }}
              </div>
            </div>
            <div *ngIf="this.questionStatus?.badge == 'Silver'" class="score-chip-silver d-flex">
              <img src="/assets/icons/silver-badge.svg" alt="">
              <div class="text-20-600-120 c-silver">
                {{'Silver badge' | translate }}
              </div>
            </div>
            <div *ngIf="this.questionStatus?.badge == 'Gold'" class="score-chip-gold d-flex">
              <img src="/assets/icons/gold-badge.svg" alt="">
              <div class="text-20-600-120 c-gold">
                {{'Gold badge' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="this.questionDetails && !this.noQuestionsFound">
        <div class="mt-5 pt-2">
          <div class="d-flex align-items-center gap-3 mb-4 ">
            <p class="text-18-500-133 mb-0 secondary">
              <!-- QNID 01 -->
              <!-- QN #{{questionIndex}} -->
              QN #{{questionDetails?.question_number}}
            </p>
            <div *ngIf="questionDetails?.sdg" class="climate-action d-flex">
                <img width="14" [src]="questionDetails.sdg?.image" alt="">
              <div class="text-12-400-133">
                <!-- {{(getTranslation(questionDetails.sdg,'name').split(' ').slice(1).join(' ')) | translate }} -->
                {{getTranslation(questionDetails.sdg,'name')}}
              </div>
            </div>
          </div>

          <!-- question -->
          <div class="col-12 px-0">
            <p class="text-20-500-120">
              <!-- {{questionDetails?.title}} -->
              {{getTranslation(questionDetails,'title')}}
            </p>
          </div>
          <!-- info link -->
          <div *ngIf="questionDetails?.info_link" class="my-3 info-link py-3 px-4">
            <div class="row">
              <div class="col-12 col-lg-5 text-15-400-121 d-flex align-items-center gap-4">
                <img src="./assets/images/link-green.svg" alt="">
                <div>{{'Kindly go through the URL to get more knowledge about the topic' | translate}}</div>
              </div>
              <div class="col-12 col-lg-7 info-link-url d-flex align-items-center justify-content-between py-3 px-4">
                <div class="w-75 text-13-400-130 text-truncate">
                  {{getTranslation(questionDetails,'info_link')}}
                </div>
                <a class="copy-icon" [href]="getTranslation(questionDetails,'info_link')" target="_blank">
                  <div class="w-100 text-14-400-157 d-flex align-items-center justify-content-end gap-3">
                    <img class="mr-3 mb-1" src="./assets/images/copy.svg" alt="">
                    <div class="text-c4">{{'Visit URL' | translate}}</div>
                  </div>
                </a>
              </div>
            </div>
          </div>

        </div>

        <div class="pb-5">
          <!-- MEDIA TYPE 1 ONLY QUESTIONS -->
          <div *ngIf="questionDetails?.options && questionDetails?.media_type == 1"
          class="col-12 mt-5 px-0 grid-layout"
          [ngClass]="{'pl-5':questionDetails?.media_type != 1}">
              <div *ngFor="let item of filteredOptions; let i = index;">
               <ng-container *ngIf="!answerSubmitted ||
                   (answerSubmitted && (item.id === questionDetails.correct_option || item === selectedOption))">
                <div class="d-flex gap-3 input-container pointer-cursor option-shadow h-100 align-items-center"
                [ngClass]="{'selected-option': item == selectedOption,
                'no-events' : this.answerSubmitted == true,
                'success': (item?.id == questionDetails.correct_option && this.answerSubmitted),
                'error': (item?.id != questionDetails.correct_option && item?.id == selectedOption?.id && this.answerSubmitted)
                }"

                (click)="selectedOption = item;selectedOption.option = alphaIndex[i];">
                  <!-- <p class="mulish-normal text-xxs font-5F5F5F mb-0 pr-3 wd-max-content">Option&nbsp;{{alphaIndex[i]}}(click)="answerClicked(item,alphaIndex[i],questionDetails.id)"</p> -->
                  <!-- <p class="mb-0 text-14-400-157">{{item.description}}</p> -->
                  <p class="mb-0 text-14-400-157">{{getTranslation(item,'description')}}</p>
                </div>
              </ng-container>
              </div>
          </div>
          <!-- MEDIA TYPE 2 QUESTIONS WITH IMAGE -->
          <div *ngIf="questionDetails?.options && questionDetails?.media_type == 2"
          class="col-12 mt-5 px-0 row question-with-image"
          [ngClass]="{'pl-5':questionDetails?.media_type != 1}">
            <div class="col-6">
                <div class="media-instruction mb-4 gap-4 d-flex justify-content-center align-items-center" >
                  <img src="assets/icons/lamp.svg" alt="">
                  <span class="text-14-400-157">{{'View this image before answering the question' | translate }}</span>
                </div>
                <div (click)="showImage()" style="cursor:pointer;min-width: 100%;height: 200px;position: relative; overflow: hidden;border-radius:0.5rem">
                  <img style="width: 100%;object-fit: cover;height: 100%;" [src]="getTranslation(questionDetails,'image')" alt="Image description">
                  <span class="view-icon text-16-400-175">{{'View' | translate}}</span>
                </div>
            </div>
            <div class="col-6 d-flex flex-column">
              <div *ngFor="let item of filteredOptions; let i = index;">
                <ng-container *ngIf="!answerSubmitted ||
                    (answerSubmitted && (item.id === questionDetails.correct_option || item === selectedOption))">
                <div class="d-flex mb-4 gap-3 input-container pointer-cursor option-shadow"
                [ngClass]="{'selected-option': item == selectedOption,
                'no-events' : this.answerSubmitted == true,
                'success': (item?.id == questionDetails.correct_option && this.answerSubmitted),
                'error': (item?.id != questionDetails.correct_option && item?.id == selectedOption?.id && this.answerSubmitted)
                }"

                (click)="selectedOption = item;selectedOption.option = alphaIndex[i];">
                  <!-- <p class="mulish-normal text-xxs font-5F5F5F mb-0 pr-3 wd-max-content">Option&nbsp;{{alphaIndex[i]}}(click)="answerClicked(item,alphaIndex[i],questionDetails.id)"</p> -->
                  <p class="mb-0 text-14-400-157">{{getTranslation(item,'description')}}</p>
                </div>
              </ng-container>
            </div>
            </div>
          </div>
          <!-- MEDIA TYPE 3 QUESTIONS WITH VIDEO -->
          <div *ngIf="questionDetails?.options && questionDetails?.media_type == 3"
          class="col-12 mt-5 px-0 row question-with-video"
          [ngClass]="{'pl-5':questionDetails?.media_type != 1}">
            <div class="col-6">
                <div class="media-instruction mb-4 gap-4 d-flex justify-content-center align-items-center">
                  <img src="assets/icons/lamp.svg" alt="">
                  <span class="text-14-400-157">{{'Watch a video before answering the question' | translate }}</span>
                </div>
                <div (click)="playVideo()" style="cursor:pointer;min-width: 100%;height: 200px;position: relative; overflow: hidden;border-radius:0.5rem">
                  <img style="width: 100%;object-fit: cover;height: 100%;" [src]="questionDetails?.videoImage" alt="Image description">
                  <img src="assets/images/play-icon.svg" alt="" class="play-icon">
                </div>
            </div>
            <div class="col-6 d-flex flex-column">
              <div *ngFor="let item of filteredOptions; let i = index;">
                <ng-container *ngIf="!answerSubmitted ||
                    (answerSubmitted && (item.id === questionDetails.correct_option || item === selectedOption))">
                <div class="d-flex mb-4 gap-3 input-container pointer-cursor option-shadow"
                [ngClass]="{'selected-option': item == selectedOption,
                'no-events' : this.answerSubmitted == true,
                'success': (item?.id == questionDetails.correct_option && this.answerSubmitted),
                'error': (item?.id != questionDetails.correct_option && item?.id == selectedOption?.id && this.answerSubmitted)
                }"

                (click)="selectedOption = item;selectedOption.option = alphaIndex[i];">
                  <!-- <p class="mulish-normal text-xxs font-5F5F5F mb-0 pr-3 wd-max-content">Option&nbsp;{{alphaIndex[i]}}(click)="answerClicked(item,alphaIndex[i],questionDetails.id)"</p> -->
                  <p class="mb-0 text-14-400-157">{{getTranslation(item,'description')}}</p>
                </div>
              </ng-container>
            </div>
            </div>
          </div>
          <div *ngIf="this.answerSubmitted && getFeedbackOrHint()" class="mt-4 submit-feedback">
            <!-- <p class="text-20-600-120 text-c4">{{selectedOption?.id == questionDetails.correct_option ? ('That’s right!' | translate) : ('Correct answer is' | translate)}}</p> -->
            <p class="text-16-500-175 text-c6">{{getFeedbackOrHint()}}</p>
          </div>
        </div>

        <div>
          <div class="d-flex mt-5 skip-area justify-content-between" [ngClass]="{'remove-skip' :questionStatus?.total_questions - questionStatus?.answered_questions === 1 }" *ngIf="correctAnswer === 0 && wrongAnswer === 0">
            <button (click)="skipToNextQuestion()" [hidden]="questionStatus?.total_questions - questionStatus?.answered_questions === 1" class="secondary-btn text-16-500-125">{{'Skip question' | translate}}</button>
            <button
              [disabled]="!selectedOption"
              class="primary-btn text-16-500-125"
              (click)="answerClicked(selectedOption,selectedOption.option,questionDetails.id)">{{'Submit answer' | translate}}</button>
          </div>
          <div class="oops-anime d-flex mt-5 justify-content-end" *ngIf="correctAnswer === 1 || wrongAnswer === 1">
            <div class="d-flex align-items-center" *ngIf="correctAnswer === 1">
              <img style="width:60px; height:60px;" src="/assets/icons/congratulations.gif" alt="great">
              <span class="d-flex flex-column">
                <span class="text-24-500-112">{{'Great!' | translate}}</span>
                <span class="text-12-500-183 text-c">{{'Your answer is correct!' | translate}}</span>
              </span>
            </div>
            <div class="d-flex align-items-center" *ngIf="wrongAnswer === 1">
              <img class="wrong" src="/assets/icons/Oops.svg" alt="great">
              <span class="d-flex flex-column">
                <span class="text-20-500-120">{{'Oops!' | translate}}</span>
                <span class="text-12-500-183 text-c">{{'Your answer is wrong!' | translate}}</span>
              </span>
            </div>
          </div>

          <div class="d-flex mt-5 wrong-anime justify-content-between" *ngIf="wrongAnswer === 2">
            <div class="oops">
              <span class="d-flex flex-column">
                <span class="text-16-500-125">{{'Oops!' | translate}}</span>
                <span class="text-12-500-183 text-c">{{'Your answer is wrong!' | translate}}</span>
              </span>
            </div>
            <button (click)="continueNextQuestion()" class="primary-btn text-16-500-125">
              {{questionStatus?.total_questions === questionStatus?.answered_questions ? ('Next' | translate) : ('Next question' | translate)}}</button>
          </div>
          <div class="points-container d-flex mt-5 justify-content-between align-items-center" *ngIf="correctAnswer === 2">
            <span class="text-24-600-216 points">
              {{this.difficultyLevel == 1 ? ('+10 points' | translate) : ('+15 points' | translate)}}
            </span>
            <button (click)="continueNextQuestion()" class="primary-btn text-16-500-125">{{questionStatus?.total_questions === questionStatus?.answered_questions ? 'Next' : 'Next question'|translate}}</button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!this.questionDetails && this.noQuestionsFound">
        <div style="min-height: 40rem;" class="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
          <!-- <p class="text-20-400-140 text-c2" *ngIf="!noQuestonSubMessage">{{'No questions found!' | translate}}</p> -->
          <p *ngIf="this.completedLevel" class="text-15-400-121 text-c2">{{'You have completed' | translate}} {{completedLevel | translate}} {{'level'|translate}}. {{'Try next level' | translate}}</p>
          <p *ngIf="noQuestonSubMessage" class="text-15-400-121 text-c2 w-50 text-center">
            {{'You’ve completed all the questions in this level.' | translate}}
            <span *ngIf="this.questionParams.category != '0'">{{'Please choose another category from the dropdown to continue playing!' | translate}}</span>
            <span *ngIf="this.questionParams.country != '0'">{{'Please choose another country from the dropdown to continue playing!' | translate}}</span>
          </p>
        </div>
      </ng-container>
    </div>
  </div>

</div>
